import React, { useState, useEffect, useRef } from 'react';

const CANTONS = [
  { value: 'AG', label: 'Aargau',                wappen: 'Wappen_Aargau_matt.svg' },
  { value: 'AI', label: 'Appenzell Innerrhoden', wappen: 'Wappen_Appenzell_Innerrhoden_matt.svg' },
  { value: 'AR', label: 'Appenzell Ausserrhoden',wappen: 'Wappen_Appenzell_Ausserrhoden_matt.svg' },
  { value: 'BE', label: 'Bern',                  wappen: 'Wappen_Bern_matt.svg' },
  { value: 'BL', label: 'Basel-Landschaft',      wappen: 'Wappen_Basel-Landschaft_matt.svg' },
  { value: 'BS', label: 'Basel-Stadt',           wappen: 'Wappen_Basel-Stadt_matt.svg' },
  { value: 'FR', label: 'Freiburg',              wappen: 'Wappen_Freiburg_matt.svg' },
  { value: 'GE', label: 'Genf',                  wappen: 'Wappen_Genf_matt.svg' },
  { value: 'GL', label: 'Glarus',                wappen: 'Wappen_Glarus_matt.svg' },
  { value: 'GR', label: 'Graubünden',            wappen: 'Wappen_Graubünden_matt.svg' },
  { value: 'JU', label: 'Jura',                  wappen: 'Wappen_Jura_matt.svg' },
  { value: 'LU', label: 'Luzern',                wappen: 'Wappen_Luzern_matt.svg' },
  { value: 'NE', label: 'Neuenburg',             wappen: 'Wappen_Neuenburg_matt.svg' },
  { value: 'NW', label: 'Nidwalden',             wappen: 'Wappen_Nidwalden_matt.svg' },
  { value: 'OW', label: 'Obwalden',              wappen: 'Wappen_Obwalden_matt.svg' },
  { value: 'SG', label: 'St. Gallen',            wappen: 'Wappen_St._Gallen_matt.svg' },
  { value: 'SH', label: 'Schaffhausen',          wappen: 'Wappen_Schaffhausen_matt.svg' },
  { value: 'SO', label: 'Solothurn',             wappen: 'Wappen_Solothurn_matt.svg' },
  { value: 'SZ', label: 'Schwyz',                wappen: 'Wappen_Schwyz_matt.svg' },
  { value: 'TG', label: 'Thurgau',               wappen: 'Wappen_Thurgau_matt.svg' },
  { value: 'TI', label: 'Tessin',                wappen: 'Wappen_Tessin_matt.svg' },
  { value: 'UR', label: 'Uri',                   wappen: 'Wappen_Uri_matt.svg' },
  { value: 'VD', label: 'Waadt',                 wappen: 'Wappen_Waadt_matt.svg' },
  { value: 'VS', label: 'Wallis',                wappen: 'Wappen_Wallis_matt.svg' },
  { value: 'ZG', label: 'Zug',                   wappen: 'Wappen_Zug_matt.svg' },
  { value: 'ZH', label: 'Zürich',                wappen: 'Wappen_Zürich_matt.svg' },
];

const WAPPEN_URL = (filename) =>
  `https://commons.wikimedia.org/w/index.php?title=Special:Redirect/file/${encodeURIComponent(filename)}&width=24`;

const CantonDropdown = ({ value, onChange, allowEmpty = true, className = '' }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const selected = CANTONS.find(c => c.value === value) || null;

  useEffect(() => {
    if (!open) return;
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  const handleSelect = (canton) => {
    onChange(canton ? canton.value : '');
    setOpen(false);
  };

  return (
    <div className={`canton-dropdown ${className}`} ref={ref}>
      <button
        type="button"
        className="canton-dropdown-toggle"
        onClick={() => setOpen(o => !o)}
      >
        {selected ? (
          <>
            <img
              src={WAPPEN_URL(selected.wappen)}
              alt={selected.label}
              className="canton-wappen"
              onError={e => { e.target.style.display = 'none'; }}
            />
            <span>{selected.label}</span>
          </>
        ) : (
          <span className="canton-placeholder">Alle Kantone</span>
        )}
        <span className="canton-arrow">▼</span>
      </button>

      {open && (
        <ul className="canton-dropdown-list">
          {allowEmpty && (
            <li
              className={`canton-option ${!value ? 'selected' : ''}`}
              onMouseDown={() => handleSelect(null)}
            >
              <span className="canton-placeholder">Alle Kantone</span>
            </li>
          )}
          {CANTONS.map(canton => (
            <li
              key={canton.value}
              className={`canton-option ${value === canton.value ? 'selected' : ''}`}
              onMouseDown={() => handleSelect(canton)}
            >
              <img
                src={WAPPEN_URL(canton.wappen)}
                alt={canton.label}
                className="canton-wappen"
                onError={e => { e.target.style.display = 'none'; }}
              />
              <span>{canton.label}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CantonDropdown;
